import { createRequestActions } from "common/helpers/action";

// User AutoComplete
export const searchUserAutoComplete = createRequestActions("APP.SMART.USER_AUTO_COMPLETE.SEARCH");
export const searchCompanyAutoComplete = createRequestActions("APP.SMART.COMPANY_AUTO_COMPLETE.SEARCH");
export const searchCompanySelect = createRequestActions("APP.SMART.COMPANY_SELECT.SEARCH");
